import React from "react";
import useAuthFlow from "../../Hooks/use-auth-flow";
import { Box, Drawer, Modal, useMediaQuery, useTheme } from "@mui/material";
import { useSpring, animated } from "@react-spring/web";
import PropTypes from "prop-types";
import LoginForm from "./login-form";
import SignupForm from "./signup-form";

const Fade = React.forwardRef(function Fade(props, ref) {
  const {
    children,
    in: open,
    onClick,
    onEnter,
    onExited,
    ownerState,
    ...other
  } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter(null, true);
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited(null, true);
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {React.cloneElement(children, { onClick })}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element.isRequired,
  in: PropTypes.bool,
  onClick: PropTypes.any,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
  ownerState: PropTypes.any,
};

const AuthModal = () => {
  const { isOpen, onClose, authType, switchAuth } = useAuthFlow();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    boxShadow: 24,
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <div>
      {isMobile ? (
        <Drawer
          anchor={"bottom"}
          open={isOpen}
          onClose={onClose}
          slotProps={{
            backdrop: {
              slot: { transition: Fade },
              sx: {
                backdropFilter: "blur(3px)",
                WebkitBackdropFilter: "blur(3px)",
                backgroundColor: "rgba(15, 15, 20, 0.42)",
              },
            },
          }}
        >
          <div className="max-h-[80dvh]">
            {authType === "signin" ? (
              <LoginForm />
            ) : (
              <>
                <SignupForm />
              </>
            )}
          </div>
        </Drawer>
      ) : (
        <Modal
          open={isOpen}
          onClose={onClose}
          closeAfterTransition
          slotProps={{
            backdrop: {
              slot: { transition: Fade },
              sx: {
                backdropFilter: "blur(3px)",
                WebkitBackdropFilter: "blur(3px)",
                backgroundColor: "rgba(15, 15, 20, 0.42)",
              },
            },
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box style={style}>
            {authType === "signin" ? (
              <LoginForm />
            ) : (
              <>
                <SignupForm />
              </>
            )}
          </Box>
        </Modal>
      )}
    </div>
  );
};

export default AuthModal;
